import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SizeRange } from '@bazis/shared/models/base.types';

@Component({
    selector: 'app-open-entity',
    templateUrl: './open-entity.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class OpenEntityComponent {
    @Input() href: string = '';

    @Input() target: string = '_self';

    @Input() type: 'button' | 'link' | 'icon' = 'button';

    @Input() linkSize: SizeRange = SizeRange.regular;
    //              mini  compact    regular    large        huge    giant
    // @Input() linkSize: 'small' | 'medium' | 'large' = 'medium';

    @Input() buttonSize: SizeRange = SizeRange.regular;
}
